export const STRING_DATA_SEPARATOR = ', ';
